export default __webpack_public_path__ + "static/media/CareDxLogo.68c9f2d2.svg";